module.exports = {
    // 公会副本的基础信息
    UpdateGuildDunBaseInfo: "UpdateGuildDunBaseInfo",

    // 更新BOSS挑战相关次数信息
    UpdateGuildBossChallengeTimes: "UpdateGuildBossChallengeTimes",

    // 首通领取状态
    UpdateFirstPassReward: "UpdateFirstPassReward",
    //集结冷却时间
    MusterCoolTime: "MusterCoolTime",
    //双倍时间
    BossActivityDoubleTime: "BossActivityDoubleTime",

    // 更新排行榜数据
    UpdateGuildDunRank: "UpdateGuildDunRank",

    // 更新击杀宝箱状态
    UpdateBoxRewardsStatus: "UpdateBoxRewardsStatus",

    //主要用于切换的时候使用
    UpdateChangeStatus: 'UpdateChangeStatus'
    
}